import React, { useState } from "react";
import { Button, Modal, Form, Container, Row, Col } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { ReduxState } from "src/redux";
import ClipLoader from "react-spinners/ClipLoader";
import {
  fetchCleanupPayeeConfig,
  payeeCleanupActionAsync,
  setPayeeCleanupConfig,
} from "src/redux/reducers/PayeeCleanupAsync";
import CreatableSelect from "react-select/creatable";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const PayeeCleanerConfig = () => {
  const [showModal, setShowModal] = useState(false);

  const dispatch = useDispatch();

  const {
    asyncJobId,
    loading,
    payeeCleanupConfig: config,
    payeeCleanupConfigLoading,
  } = useSelector((state: ReduxState) => state.PayeeCleanupAsync);

  //   const [config, setConfig] = useState(
  //     reduxConfig || {
  //       removeDates: true,
  //       removeCurrencyValues: true,
  //       removePhoneNumbers: true,
  //       removeTwoLetterStates: true,
  //       removeHashNumbers: true,
  //       replacePunctuation: true,
  //       removeSpecialCharacters: true,
  //       removeNumbersFromWords: true,
  //       removeExtraSpaces: true,
  //       removeShortNumbers: false,
  //       shortNumberThreshold: 3,
  //       wordsOrPhrasesToRemove: [],
  //       regexesToRemove: [],
  //     }
  //   );

  const handleChange = (e) => {
    if (e.target) {
      const { name, value, type, checked } = e.target;
      dispatch(
        setPayeeCleanupConfig({
          ...config,
          [name]: type === "checkbox" ? checked : value,
        })
      );
    }
  };

  const handleApply = () => {
    dispatch(payeeCleanupActionAsync(config));
    setShowModal(false);
  };

  React.useEffect(() => {
    dispatch(fetchCleanupPayeeConfig());
  }, []);

  if (!config) {
    return null;
  }
  return (
    <>
      {!loading && !payeeCleanupConfigLoading && (
        <Button variant="secondary" onClick={() => setShowModal(true)}>
          <FontAwesomeIcon icon="cog" />
          <span className="ml-1">Payee Cleanup</span>
        </Button>
      )}
      {loading && <ClipLoader />}

      <Modal show={showModal} onHide={() => setShowModal(false)} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>Payee Cleanup Configuration</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Container>
            <Form>
              <Row>
                <Col md={6}>
                  <Form.Group>
                    <Form.Check
                      type="checkbox"
                      label="Remove Dates"
                      name="removeDates"
                      checked={config.removeDates}
                      onChange={handleChange}
                    />
                  </Form.Group>
                  <Form.Group>
                    <Form.Check
                      type="checkbox"
                      label="Remove Currency Values"
                      name="removeCurrencyValues"
                      checked={config.removeCurrencyValues}
                      onChange={handleChange}
                    />
                  </Form.Group>
                  <Form.Group>
                    <Form.Check
                      type="checkbox"
                      label="Remove Phone Numbers"
                      name="removePhoneNumbers"
                      checked={config.removePhoneNumbers}
                      onChange={handleChange}
                    />
                  </Form.Group>
                  <Form.Group>
                    <Form.Check
                      type="checkbox"
                      label="Remove Two Letter States"
                      name="removeTwoLetterStates"
                      checked={config.removeTwoLetterStates}
                      onChange={handleChange}
                    />
                  </Form.Group>
                  <Form.Group>
                    <Form.Check
                      type="checkbox"
                      label="Remove Numbers Starting with #"
                      name="removeHashNumbers"
                      checked={config.removeHashNumbers}
                      onChange={handleChange}
                    />
                  </Form.Group>
                  <Form.Group>
                    <Form.Check
                      type="checkbox"
                      label="Replace Punctuation With Spaces"
                      name="replacePunctuation"
                      checked={config.replacePunctuation}
                      onChange={handleChange}
                    />
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group>
                    <Form.Check
                      type="checkbox"
                      label="Remove Special Characters"
                      name="removeSpecialCharacters"
                      checked={config.removeSpecialCharacters}
                      onChange={handleChange}
                    />
                  </Form.Group>
                  <Form.Group>
                    <Form.Check
                      type="checkbox"
                      label="Remove Numbers from Words"
                      name="removeNumbersFromWords"
                      checked={config.removeNumbersFromWords}
                      onChange={handleChange}
                    />
                  </Form.Group>
                  <Form.Group>
                    <Form.Check
                      type="checkbox"
                      label="Remove Extra Spaces"
                      name="removeExtraSpaces"
                      checked={config.removeExtraSpaces}
                      onChange={handleChange}
                    />
                  </Form.Group>
                  <Form.Group>
                    <Form.Check
                      type="checkbox"
                      label="Remove Short Numbers"
                      name="removeShortNumbers"
                      checked={config.removeShortNumbers}
                      onChange={handleChange}
                    />
                  </Form.Group>
                  <Form.Group>
                    {/* <Form.Label>Short Number Threshold</Form.Label> */}
                    <Form.Control
                      type="number"
                      name="shortNumberThreshold"
                      value={config.shortNumberThreshold}
                      onChange={handleChange}
                      min="1"
                    />
                    <Form.Label>characters or less</Form.Label>
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <Col md={12}>
                  <Form.Group>
                    <Form.Label>Words to remove</Form.Label>
                    <CreatableSelect
                      placeholder="Enter words "
                      name="wordsOrPhrasesToRemove"
                      isMulti
                      onChange={(e) => {
                        dispatch(
                          setPayeeCleanupConfig({
                            ...config,
                            wordsOrPhrasesToRemove: e?.map((x) => x.value),
                          })
                        );
                      }}
                      options={(config.wordsOrPhrasesToRemove || []).map(
                        (x) => ({
                          label: x,
                          value: x,
                        })
                      )}
                      value={(config.wordsOrPhrasesToRemove || []).map((x) => ({
                        label: x,
                        value: x,
                      }))}
                    />
                    {/* <Form.Control
                      type="text"
                      name="wordsOrPhrasesToRemove"
                      value={config.wordsOrPhrasesToRemove}
                      onChange={handleChange}
                      placeholder="e.g., item, special, test"
                    /> */}
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <Col md={12}>
                  <Form.Group>
                    <Form.Label>Regexes to Remove</Form.Label>
                    <CreatableSelect
                      placeholder="Enter regexes"
                      isMulti
                      onChange={(e) => {
                        dispatch(
                          setPayeeCleanupConfig({
                            ...config,
                            regexesToRemove: e?.map((x) => x.value),
                          })
                        );
                      }}
                      name="regexesToRemove"
                      options={(config.regexesToRemove || []).map((x) => ({
                        label: x,
                        value: x,
                      }))}
                      value={(config.regexesToRemove || []).map((x) => ({
                        label: x,
                        value: x,
                      }))}
                    />
                    {/* <Form.Control
                      type="text"
                      name="regexesToRemove"
                      value={config.regexesToRemove}
                      onChange={handleChange}
                      placeholder="e.g., \b\w{1,3}\b, \d{5}"
                    /> */}
                  </Form.Group>
                </Col>
              </Row>
            </Form>
          </Container>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal(false)}>
            Cancel
          </Button>
          <Button variant="primary" onClick={handleApply}>
            Apply Configuration
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default PayeeCleanerConfig;
